<template>
    <Modal :title="activation.name || ''" width="push-40" section="showAudienceItem">
        <div class="row mt-0 mb-4" v-if="is_loading">
            <div class="col-12">
                <ShowPageLoading></ShowPageLoading>
            </div>
        </div>
        <div class="row mt-0 mb-4 d-flex justify-content-between" v-else>
            <div class="col-md-5">
                <div class="mt-0 mb-2">
                    <h3 style="border-bottom: 1px solid #ff7516;">Activation Data</h3>

                    <ul v-for="(item, index) in activation.dataset" v-if="activation.dataset" class="list-no-bullets-no-padding-left">
                        <li class="pb-3" v-if="index === 0 && activation.dataset.length === 1">
                            <span v-html="getActivationQueryValue(activation)"></span>
                        </li>

                        <li>Analysis Type: <strong>{{ item.analysistype || '' }} </strong></li>

                        <li v-if="item.startDate">Start Date: <strong>{{ item.startDate || '' }} </strong></li>
                        <li v-if="item.endDate">End Date: <strong>{{ item.endDate || '' }} </strong></li>

                        <li v-if="item.cohort_name && item.analysistype === 'Cohorts'">Name: {{ item.cohort_name }}</li>

                        <li v-if="item.signalproviders.length"><span v-html="showHideValue('signal-providers', index)" class="toggle-button" @click="toggleShow('signal-providers', index)"></span> {{ item.signalproviders.length }} Signal Providers </li>
                        <ul v-if="item.signalproviders.length" :class="{'hide-toggle' : !showedData.includes('signal-providers_' + index)}">
                            <li v-for="data in item.signalproviders"> {{ data }} </li>
                        </ul>

                        <li v-if="item.categories.length"><span v-html="showHideValue('categories', index)" class="toggle-button" @click="toggleShow('categories', index)"></span> {{ item.categories.length }} Categories</li>
                        <ul v-if="item.categories.length" :class="{'hide-toggle' : !showedData.includes('categories_' + index)}">
                            <li v-for="item in item.categories"> {{ item }} </li>
                        </ul>

                        <li v-if="item.analysisdata.length"><span v-html="showHideValue('analysisdata', index)" class="toggle-button" @click="toggleShow('analysisdata', index)"></span> {{ item.analysisdata.length }} Brands</li>
                        <ul v-if="item.analysisdata.length" :class="{'hide-toggle' : !showedData.includes('analysisdata_' + index)}">
                            <li v-for="item in item.analysisdata"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_categories.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_categories', index)" class="toggle-button" @click="toggleShow('apps_categories', index)"></span> {{ item.apps_categories.length }} Categories</li>
                        <ul v-if="item.apps_categories.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_categories_' + index)}">
                            <li v-for="item in item.apps_categories"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_tags.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_tags', index)" class="toggle-button" @click="toggleShow('apps_tags', index)"></span> {{ item.apps_tags.length }} Tags</li>
                        <ul v-if="item.apps_tags.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_tags_' + index)}">
                            <li v-for="item in item.apps_tags"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_bundle_ids.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_bundle_ids', index)" class="toggle-button" @click="toggleShow('apps_bundle_ids', index)"></span> {{ item.apps_bundle_ids.length }} App Names</li>
                        <ul v-if="item.apps_bundle_ids.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_bundle_ids_' + index)}">
                            <li v-for="item in item.apps_bundle_ids"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_device_os.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_device_os', index)" class="toggle-button" @click="toggleShow('apps_device_os', index)"></span> {{ item.apps_device_os.length }} Device OS</li>
                        <ul v-if="item.apps_device_os.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_device_os_' + index)}">
                            <li v-for="item in item.apps_device_os"> {{ item }} </li>
                        </ul>

                        <li v-if="item.locations.length"><span v-html="showHideValue('locations', index)" class="toggle-button" @click="toggleShow('locations', index)"></span> {{ item.locations.length }} Locations</li>
                        <ul v-if="item.locations.length" :class="{'hide-toggle' : !showedData.includes('locations_' + index)}">
                            <li v-for="item in item.locations"> {{ item }} </li>
                        </ul>

                        <li v-if="item.countries.length && ['POI', 'Anonymized', 'Apps'].includes(item.analysistype)"><span v-html="showHideValue('countries', index)" class="toggle-button" @click="toggleShow('countries', index)"></span> {{ item.countries.length }} Countries</li>
                        <ul v-if="item.countries.length && ['POI', 'Anonymized', 'Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('countries_' + index)}">
                            <li v-for="item in item.countries"> {{ item }} </li>
                        </ul>

                        <li v-if="item.states.length"><span v-html="showHideValue('states', index)" class="toggle-button" @click="toggleShow('states', index)"></span> {{ item.states.length }} States</li>
                        <ul v-if="item.states.length" :class="{'hide-toggle' : !showedData.includes('states_' + index)}">
                            <li v-for="item in item.states"> {{ item }} </li>
                        </ul>

                        <li v-if="item.dmas.length"><span v-html="showHideValue('dmas', index)" class="toggle-button" @click="toggleShow('dmas', index)"></span> {{ item.dmas.length }} DMAs</li>
                        <ul v-if="item.dmas.length" :class="{'hide-toggle' : !showedData.includes('dmas_' + index)}">
                            <li v-for="item in item.dmas"> {{ item }} </li>
                        </ul>

                        <li v-if="item.cities.length"><span v-html="showHideValue('cities', index)" class="toggle-button" @click="toggleShow('cities', index)"></span> {{ item.cities.length }} Cities</li>
                        <ul v-if="item.cities.length" :class="{'hide-toggle' : !showedData.includes('cities_' + index)}">
                            <li v-for="item in item.cities"> {{ item }} </li>
                        </ul>

                        <li v-if="item.zipcodes.length"><span v-html="showHideValue('zipcodes', index)" class="toggle-button" @click="toggleShow('zipcodes', index)"></span> {{ item.zipcodes.length }} Zip Codes</li>
                        <ul v-if="item.zipcodes.length" :class="{'hide-toggle' : !showedData.includes('zipcodes_' + index)}">
                            <li v-for="item in item.zipcodes"> {{ item }} </li>
                        </ul>

                        <li v-if="item.limits && ((item.limits.time && item.limits.time.process) || (item.limits.distance && item.limits.distance.process))"><span v-html="showHideValue('limits', index)" class="toggle-button" @click="toggleShow('limits', index)"></span> Limits</li>
                        <ul v-if="item.limits && ((item.limits.time && item.limits.time.process) || (item.limits.distance && item.limits.distance.process))" :class="{'hide-toggle' : !showedData.includes('limits_' + index)}">
                            <li v-if="item.limits.time && item.limits.time.process"><strong>Time:</strong> {{ item.limits.time.start.toString().padStart(2, '0') }}:00 - {{ item.limits.time.end.toString().padStart(2, '0') }}:59</li>
                            <li v-if="item.limits.distance && item.limits.distance.process"><strong>Distance:</strong> {{ item.limits.distance.distance }} {{ item.limits.distance.unit }} </li>
                        </ul>

                        <li class="mt-3" v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields"><strong>Selected Fields:</strong></li>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.geoLocation">
                            <span v-html="showHideValue('geo', index)" class="toggle-button" @click="toggleShow('geo', index)"></span>
                            {{ item.selectedFields.geoLocation.length }} Geo Location
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.geoLocation" :class="{'hide-toggle' : !showedData.includes('geo_' + index)}">
                            <li v-for="item in item.selectedFields.geoLocation"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.Advertising">
                            <span v-html="showHideValue('advertising', index)" class="toggle-button" @click="toggleShow('advertising', index)"></span>
                            {{ item.selectedFields.Advertising.length }} Advertising
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.Advertising" :class="{'hide-toggle' : !showedData.includes('advertising_' + index)}">
                            <li v-for="item in item.selectedFields.Advertising"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.userDetails">
                            <span v-html="showHideValue('user_details', index)" class="toggle-button" @click="toggleShow('user_details', index)"></span>
                            {{ item.selectedFields.userDetails.length }} User Details
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.userDetails" :class="{'hide-toggle' : !showedData.includes('user_details_' + index)}">
                            <li v-for="item in item.selectedFields.userDetails"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.ipDetails">
                            <span v-html="showHideValue('ip_details', index)" class="toggle-button" @click="toggleShow('ip_details', index)"></span>
                            {{ item.selectedFields.ipDetails.length }} IP Details
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.ipDetails" :class="{'hide-toggle' : !showedData.includes('ip_details_' + index)}">
                            <li v-for="item in item.selectedFields.ipDetails"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.privacy">
                            <span v-html="showHideValue('privacy', index)" class="toggle-button" @click="toggleShow('privacy', index)"></span>
                            {{ item.selectedFields.privacy.length }} Privacy
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.privacy" :class="{'hide-toggle' : !showedData.includes('privacy_' + index)}">
                            <li v-for="item in item.selectedFields.privacy"> {{ item }} </li>
                        </ul>

                        <li class="mt-3" v-if="index === 0 && activation.dataset.length > 1">
                            <span v-html="getActivationQueryValue(activation)"></span>
                        </li>
                    </ul>

                    <ul v-if="activation.dataset && Object.keys(activation.dataset[0].competitors).length !== 0" class="list-no-bullets-no-padding-left">
                        <li><strong>Competitors: </strong></li>
                        <li v-if="activation.dataset[0].competitors.distance">Distance: <strong>up to {{ activation.dataset[0].competitors.distance + ' ' + activation.dataset[0].competitors.unit  }} </strong></li>

                        <li v-if="activation.dataset[0].competitors.categories.length"><span v-html="showHideValue('categories', 'comp')" class="toggle-button" @click="toggleShow('categories', 'comp')"></span> {{ activation.dataset[0].competitors.categories.length }} Categories</li>
                        <ul v-if="activation.dataset[0].competitors.categories.length" :class="{'hide-toggle' : !showedData.includes('categories_comp')}">
                            <li v-for="item in activation.dataset[0].competitors.categories"> {{ item }} </li>
                        </ul>

                        <li v-if="activation.dataset[0].competitors.analysisdata.length"><span v-html="showHideValue('analysisdata', 'comp')" class="toggle-button" @click="toggleShow('analysisdata', 'comp')"></span> {{ activation.dataset[0].competitors.analysisdata.length }} Brands</li>
                        <ul v-if="activation.dataset[0].competitors.analysisdata.length" :class="{'hide-toggle' : !showedData.includes('analysisdata_comp')}">
                            <li v-for="item in activation.dataset[0].competitors.analysisdata"> {{ item }} </li>
                        </ul>
                    </ul>

                </div>
            </div>
            <div class="col-md-6">
                <div class="mt-0 mb-4">
                    <h3 style="border-bottom: 1px solid #ff7516;">Audience Details</h3>
                    <div class="row mt-3">
                        <v-tooltip top v-if="activation.eids">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" small class="mt-n1 text-info">
                                    mdi-information-outline
                                </v-icon>
                            </template>
                            <span>
                                Audience Name
                             </span>
                        </v-tooltip>

                        <div class="form-inline col-md-4 py-0"><strong> Audience Name: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ activation.name || '' }} </div>
                    </div>

                    <div class="row mt-6" v-if="(activation.dataset && activation.dataset[0] && activation.dataset[0].analysistype !== 'Anonymized')">
                        <div class="form-inline col-md-4 py-0 align-self-start"><strong> Analyses: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <ul class="mb-0" style="list-style:none;padding-left:0;">
                                <li>Audience</li>
                                <li v-for="(analyse, index) in activation.analyses" v-if="activation.analyses && analyse.process">
                                    <span v-if="analyse.name == 'Frequency' && analyse.day_part">Day Part </span>
                                    <span v-if="analyse.name == 'Frequency' && !analyse.day_part">Daily </span>
                                    {{ analyse.name || '' }}
                                </li>
                            </ul>

                        </div>
                    </div>

                    <div class="row mt-6" v-if="activation.isCompleted || (activation.status && activation.status.code === 106)">
                        <div class="form-inline col-md-4 py-0  align-self-start"><strong>Analytics:</strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <ul class="mb-0" style="list-style: none;padding-left:0;">
                                <li v-for="item in activation.totals">
                                    <v-tooltip left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on"> {{ item.label }}: {{ new Intl.NumberFormat().format(item.count) }} </span>
                                        </template>
                                        <span> {{ item.desc }} </span>
                                    </v-tooltip>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="row mt-6" v-if="activation.abnormality">
                        <div class="form-inline col-md-4 py-0"><strong> Anomaly detection: </strong> </div>
                        <div class="form-inline col-md-8 py-0" v-if="activation.abnormality !== 2">All</div>
                        <div class="form-inline col-md-8 py-0" v-if="activation.abnormality === 2">Normal</div>
                    </div>

                    <div class="row mt-6" v-if="activation.filters && activation.filters.length">
                        <div class="form-inline col-md-4 py-0 align-self-start"><strong> Filters: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <ul class="mb-0" style="list-style:none;padding-left:0;">
                                <li v-for="filter in activation.filters" v-if="activation.filters">
                                    {{ filter || '' }}
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>

                <div class="mt-8" v-if="activation.results && activation.results.Analyses && activation.results.Analyses.length > 0">
                    <h3 style="border-bottom: 1px solid #ff7516;">Analyses Results</h3>
                    <div class="row mt-3 mb-2" v-for="item in activation.results.Analyses" v-if="item.name !== 'CrossVisitation'">

                        <div class="form-inline col-md-4 py-0">
                            <strong class="text-capitalize">{{ item.name }}: </strong>
                        </div>
                        <div class="form-inline col-md-8 py-0">
                            <ResultsUrl :uri="item.file.uri" :url="item.file.url"></ResultsUrl>
                        </div>
                    </div>
                </div>
                <div class="mt-8" v-if="activation.analyses && activation.analyses.crossvisitation.process">
                    <h3 style="border-bottom: 1px solid #ff7516;">Cross Visitation Analysis</h3>
                    <div v-if="activation.results && activation.results.Analyses && activation.results.Analyses.length > 0">
                        <div class="row mt-3 mb-2" v-for="item in activation.results.Analyses" v-if="item.name === 'CrossVisitation'">
                            <div class="form-inline col-md-4 py-0">
                                <strong>{{ item.name }}: </strong>
                            </div>
                            <div class="form-inline col-md-8 py-0">
                                <ResultsUrl :uri="item.file.uri" :url="item.file.url"></ResultsUrl>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-1" v-if="activation.analyses.crossvisitation.process">
                        <ul class="col-12 mb-0 pb-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.startDate">
                            <li>Start Date: <strong>{{ activation.analyses.crossvisitation.startDate }}</strong></li>
                        </ul>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.startDate">
                            <li>End Date: <strong>{{ activation.analyses.crossvisitation.endDate }}</strong></li>
                        </ul>

                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.abnormality">
                            <li v-if="activation.analyses.crossvisitation.abnormality !== 2">Anomaly detection: <strong>All</strong></li>
                            <li v-if="activation.analyses.crossvisitation.abnormality === 2">Anomaly detection: <strong>Normal</strong></li>
                        </ul>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.categories.length">
                            <li><span v-html="showHideValue('cross-categories', 5)" class="toggle-button" @click="toggleShow('cross-categories', 5)"></span> {{ activation.analyses.crossvisitation.categories.length }} Categories</li>
                            <ul v-if="activation.analyses.crossvisitation.categories" :class="{'hide-toggle' : !showedData.includes('cross-categories_' + 5)}">
                                <li v-for="data in activation.analyses.crossvisitation.categories"> {{ data }} </li>
                            </ul>
                        </ul>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.brands.length">
                            <li><span v-html="showHideValue('cross-brands', 5)" class="toggle-button" @click="toggleShow('cross-brands', 5)"></span> {{ activation.analyses.crossvisitation.brands.length }} Brands</li>
                            <ul v-if="activation.analyses.crossvisitation.brands" :class="{'hide-toggle' : !showedData.includes('cross-brands_' + 5)}">
                                <li v-for="data in activation.analyses.crossvisitation.brands"> {{ data }} </li>
                            </ul>
                        </ul>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.locations && activation.analyses.crossvisitation.locations.length">
                            <li><span v-html="showHideValue('cross-locations', 5)" class="toggle-button" @click="toggleShow('cross-locations', 5)"></span> {{ activation.analyses.crossvisitation.locations.length }} Locations</li>
                            <ul v-if="activation.analyses.crossvisitation.locations" :class="{'hide-toggle' : !showedData.includes('cross-locations_' + 5)}">
                                <li v-for="data in activation.analyses.crossvisitation.locations"> {{ data }} </li>
                            </ul>
                        </ul>
                        <div v-if="activation.analyses.crossvisitation.location">
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.location.countries.length">
                                <li><span v-html="showHideValue('cross-countries', 5)" class="toggle-button" @click="toggleShow('cross-countries', 5)"></span> {{ activation.analyses.crossvisitation.location.countries.length }} Countries</li>
                                <ul v-if="activation.analyses.crossvisitation.location.countries" :class="{'hide-toggle' : !showedData.includes('cross-countries_' + 5)}">
                                    <li v-for="data in activation.analyses.crossvisitation.location.countries"> {{ data }} </li>
                                </ul>
                            </ul>
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.location.states.length">
                                <li><span v-html="showHideValue('cross-states', 5)" class="toggle-button" @click="toggleShow('cross-states', 5)"></span> {{ activation.analyses.crossvisitation.location.states.length }} States</li>
                                <ul v-if="activation.analyses.crossvisitation.location.states" :class="{'hide-toggle' : !showedData.includes('cross-states_' + 5)}">
                                    <li v-for="data in activation.analyses.crossvisitation.location.states"> {{ data }} </li>
                                </ul>
                            </ul>
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.location.cities.length">
                                <li><span v-html="showHideValue('cross-cities', 5)" class="toggle-button" @click="toggleShow('cross-cities', 5)"></span> {{ activation.analyses.crossvisitation.location.cities.length }} Cities</li>
                                <ul v-if="activation.analyses.crossvisitation.location.cities" :class="{'hide-toggle' : !showedData.includes('cross-cities_' + 5)}">
                                    <li v-for="data in activation.analyses.crossvisitation.location.cities"> {{ data }} </li>
                                </ul>
                            </ul>
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.location.dmas.length">
                                <li><span v-html="showHideValue('cross-dmas', 5)" class="toggle-button" @click="toggleShow('cross-dmas', 5)"></span> {{ activation.analyses.crossvisitation.location.dmas.length }} DMAs</li>
                                <ul v-if="activation.analyses.crossvisitation.location.dmas" :class="{'hide-toggle' : !showedData.includes('cross-dmas_' + 5)}">
                                    <li v-for="data in activation.analyses.crossvisitation.location.dmas"> {{ data }} </li>
                                </ul>
                            </ul>
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.location.zipcodes.length">
                                <li><span v-html="showHideValue('cross-zipcodes', 5)" class="toggle-button" @click="toggleShow('cross-zipcodes', 5)"></span> {{ activation.analyses.crossvisitation.location.zipcodes.length }} Zipcodes</li>
                                <ul v-if="activation.analyses.crossvisitation.location.zipcodes" :class="{'hide-toggle' : !showedData.includes('cross-zipcodes_' + 5)}">
                                    <li v-for="data in activation.analyses.crossvisitation.location.zipcodes"> {{ data }} </li>
                                </ul>
                            </ul>
                        </div>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.limits && ((activation.analyses.crossvisitation.limits.time && activation.analyses.crossvisitation.limits.time.process) || (activation.analyses.crossvisitation.limits.distance && activation.analyses.crossvisitation.limits.distance.process))">
                            <li><span v-html="showHideValue('cross-limits', 5)" class="toggle-button" @click="toggleShow('cross-limits', 5)"></span> Limits</li>
                            <ul :class="{'hide-toggle' : !showedData.includes('cross-limits_' + 5)}">
                                <li v-if="activation.analyses.crossvisitation.limits.time && activation.analyses.crossvisitation.limits.time.process"><strong>Time:</strong> {{ activation.analyses.crossvisitation.limits.time.start.toString().padStart(2, '0') }}:00 - {{ activation.analyses.crossvisitation.limits.time.end.toString().padStart(2, '0') }}:59</li>
                                <li v-if="activation.analyses.crossvisitation.limits.distance && activation.analyses.crossvisitation.limits.distance.process"><strong>Distance:</strong> {{ activation.analyses.crossvisitation.limits.distance.distance }} {{ activation.analyses.crossvisitation.limits.distance.unit }} </li>
                            </ul>
                        </ul>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="activation.analyses.crossvisitation.filters && activation.analyses.crossvisitation.filters.length">
                            <li><span v-html="showHideValue('cross-filters', 5)" class="toggle-button" @click="toggleShow('cross-filters', 5)"></span> Filters</li>
                            <ul v-if="activation.analyses.crossvisitation.filters" :class="{'hide-toggle' : !showedData.includes('cross-filters_' + 5)}">
                                <li v-for="data in activation.analyses.crossvisitation.filters"> {{ data }} </li>
                            </ul>
                        </ul>
                    </div>
                </div>

                <div class="mt-8">
                    <h3 style="border-bottom: 1px solid #ff7516;">Audience Properties</h3>
                    <div class="row mt-3">
                        <div class="form-inline col-md-4 py-0"><strong> Status: </strong> </div>
                        <div class="form-inline col-md-4 py-0">
                            <v-progress-linear
                                v-if="!activation.isCompleted && activation.status && !activation.status.isError && (![106, 107].includes(activation.status.code))"
                                color="#fb7e42"
                                height="10"
                                indeterminate
                                rounded
                            ></v-progress-linear>

                            <v-progress-linear
                                v-if="activation.isCompleted"
                                color="success"
                                height="10"
                                value="100"
                                rounded
                            ></v-progress-linear>

                            <v-progress-linear
                                v-if="activation.status && activation.status.code === 107"
                                color="info"
                                height="10"
                                value="100"
                                rounded
                            ></v-progress-linear>

                            <span :class="(activation.status && activation.status.isError) ? 'text-danger' : ''">
                                {{ activation.status ? activation.status.string : '' }}

                                <v-tooltip top v-if="!activation.isCompleted && (activation.status && activation.status.message)" :color="(activation.status && activation.status.isError) ? 'error' : ''">
                                    <template v-slot:activator="{ on, attrs }">
                                        <i v-bind="attrs" v-on="on" class="fas fa-info-circle" :class="(activation.status && activation.status.isError) ? 'text-danger' : 'text-info'"></i>
                                    </template>
                                    <span>
                                        {{ activation.status ? activation.status.message : '' }}
                                    </span>
                                </v-tooltip>
                            </span>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="form-inline col-md-4 py-0"><strong> Created at: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ activation.created_at || '' }} </div>
                    </div>
                    <div class="row mt-3">
                        <div class="form-inline col-md-4 py-0"><strong> Updated at: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ activation.updated_at || '' }} </div>
                    </div>
                    <div class="row mt-3">
                        <div class="form-inline col-md-4 py-0"><strong> Created by: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ activation.user_id || 'Default' }} | {{ activation.company_id || 'Default' }}</div>
                    </div>
                </div>

            </div>
            <!--form-group-->
        </div>
    </Modal>
</template>

<script>
import Modal from '../Modal'
import api from "../../api/analyses/activations";
import mixins from "../../mixin";
import ResultsUrl from "./partials/shared/ResultsUrl.vue";
import ShowPageLoading from "../general/ShowPageLoading.vue";
export default {
    name: "ShowAudienceItem",
    mixins: [mixins],
    components: {
        ShowPageLoading,
        ResultsUrl,
        Modal
    },
    data: () => ({
        activation: [],
        is_loading: true,

        showedData: [],
    }),
    methods: {
        async fetchAudience() {
            await api.getSingleAudience({
                _token: $('meta[name="_token"]').attr('content'),
                audience: this.$parent.showingAudience
            })
            .then(res => {
                if (res.status === 202) {
                    this.$toast.open({
                        message: 'This audience item was removed.',
                        type: "error",
                    })
                    this.$parent.showAudienceItem = false
                    this.$parent.showingAudience = ''
                    window.history.pushState({}, null, window.location.href.split('/').splice(0, 6).join('/'));
                }
                this.activation = res.data.activation

                this.is_loading = false
            })
        }
    },
    mounted() {
        this.fetchAudience()
    }
}
</script>

<style scoped>

</style>